import {FONT_FAMILY} from "@/utils/font-family";

interface IProps {
    date: Date;
}
const MessageDateTimeComponent = ({date}: IProps) => {
    // API timestamps are UTC; normalize them to the user's local timezone for display.
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    const dayName = localDate.toLocaleDateString([], { weekday: 'short' });

    // Get the time in H:MM AM/PM format
    const time = localDate.toLocaleTimeString([], {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    });
    return <span style={{...FONT_FAMILY.Lexend(400, 11)}}>{`${dayName} ${time}`}</span>
}

export {MessageDateTimeComponent}